import { css } from '@emotion/core';

export default css`
  position: absolute;
  right: 0;
  top: 0;
  margin: 8px;
  z-index: 1;
`;
